import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";

class TextPage extends Component {
    constructor() {
        super();
        this.state = {
            title: null,
            image: null,
            text: null
        }
    }

    componentDidMount() {
        axios.get("/wp-json/vv/page/?p=" + this.props.match.path)
            .then(resp => {
                this.setState({
                    title: resp.data.page_title,
                    image: resp.data.acf_content.image.value.url || null,
                    text: resp.data.acf_content.text.value
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    render() {
        var hasImageClass = "";
        if (this.state.image !== null) {
            hasImageClass = " has-image";
        }

        return <div className={"text-image-page" + hasImageClass}>
            <img className="main-image" src={this.state.image} />
            <div className="content">
                <h1 className="page-title">{this.state.title}</h1>
                <div className="html-content" dangerouslySetInnerHTML={{__html: this.state.text}}></div>
            </div>
        </div>
    }
}

// export default TextPage;
export default connect(null)(withRouter(TextPage));